import React from 'react';
import { ArrowRight } from 'lucide-react';

export interface AdminSectionData {
  label: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
  description: string;
}

interface AdminSectionsGridProps {
  sections: AdminSectionData[];
  onLinkClick: (href: string, e: React.MouseEvent) => void;
}

export const AdminSectionsGrid: React.FC<AdminSectionsGridProps> = ({ sections, onLinkClick }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {sections.map((section) => (
        <button
          key={section.label}
          onClick={(e) => onLinkClick(section.href, e)}
          className="group flex items-start gap-3 p-4 text-left rounded-lg bg-white border border-gray-100 hover:border-gray-200 hover:shadow-sm transition-all duration-200"
        >
          <div className="flex-shrink-0 mt-0.5">
            <section.icon className="w-5 h-5 text-gray-600 group-hover:text-blue-600 transition-colors" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between">
              <span className="font-medium text-gray-900 group-hover:text-blue-600 transition-colors text-sm">
                {section.label}
              </span>
              <ArrowRight className="w-3 h-3 text-muted-foreground group-hover:text-blue-600 group-hover:translate-x-0.5 transition-all" />
            </div>
            <p className="text-xs text-gray-500 mt-1 line-clamp-2 group-hover:text-gray-600 transition-colors">
              {section.description}
            </p>
          </div>
        </button>
      ))}
    </div>
  );
};